/* eslint-disable import/prefer-default-export */
import config from 'config';
import { ApiInfo, CalendarRedirectResponse } from 'Internal.CommonAPI';
import { useAuthenticatedApiClient } from '../../base';

const customJsonHeader = {
  'Content-Type': 'application/json',
};

export const useCommonApi = (token?: string) => {
  const authenticatedApiClient = useAuthenticatedApiClient(token || undefined);
  const commonApiClient = authenticatedApiClient;

  return {
    getInfo(userToken?: string) {
      const headers =
        userToken !== undefined && userToken.trim() !== ''
          ? {
              ...customJsonHeader,
              Authorization: `Token ${userToken}`,
            }
          : customJsonHeader;

      return commonApiClient
        .get(`${config.CORE_URL}/api/info/`, {
          headers,
        })
        .json<ApiInfo>();
    },
    getCalendarRedirect() {
      return commonApiClient
        .post(`${config.CORE_URL}/api/sso/calendar-redirect/`, {
          headers: customJsonHeader,
        })
        .json<CalendarRedirectResponse>();
    },
  };
};
